import { render, staticRenderFns } from "./factureManuel.vue?vue&type=template&id=51289fd3&scoped=true"
import script from "./factureManuel.vue?vue&type=script&lang=js"
export * from "./factureManuel.vue?vue&type=script&lang=js"
import style0 from "./factureManuel.vue?vue&type=style&index=0&id=51289fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51289fd3",
  null
  
)

export default component.exports